import axios from 'axios';

/**
 * Logs a user event to the backend.
 * @param {string} event - The event name (e.g., 'dashboard_access', 'login_success').
 * @param {string} description - Human-readable description of the event.
 * @param {Object} metadata - Optional additional data to include in the log.
 */
export const logUserEvent = async (event, description, metadata = {}) => {
    try {
        const userId = localStorage.getItem('userId');
        if (!userId) {
            console.warn('Cannot log user event: No userId found in localStorage');
            return;
        }

        await axios.post('/api/user_logs/', {
            user_id: userId,
            event,
            description,
            ...metadata
        });
    } catch (error) {
        // We generally don't want to alert the user if logging fails,
        // but we should log it to the console for debugging.
        console.error('Failed to log user event:', error);
    }
};
